import { BuisnessPromotion } from "src/app/models/common";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { Component, NgZone, OnInit, OnDestroy } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { AddAdminPostComponent } from "src/app/shared/components/add-admin-post/add-admin-post.component";
import { NavigationService } from "../../../providers/navigation.service";
import { ActivatedRoute, Router } from "@angular/router";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { YoutubeEmbedVideoComponent } from "../../new-v2-pages/new-v2-component/youtube-embed-video/youtube-embed-video.component";
import { AddBusinessPostComponent } from "../../new-v2-pages/new-v2-component/add-business-post/add-business-post.component";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { PublicPostSettingsComponent } from "../../new-v2-pages/new-v2-component/public-post-settings/public-post-settings.component";

@Component({
  selector: "sm-post",
  templateUrl: "./post.component.html",
  styleUrls: ["./post.component.scss"],
})
export class PostComponent implements OnInit, OnDestroy {
  private _apiSubscription: Subscription = new Subscription();
  public adminPostList: BuisnessPromotion[] = [];
  public modelSubscription: Subscription = new Subscription();
  public page: number = 1;
  public isLoading: boolean = false;
  constructor(
    private _modelRef: MatDialog,
    private _apiService: ApiService,
    private _ngZone: NgZone,
    private dialog: MatDialog,
    private router: Router,
    private _navService: NavigationService,
    private route: ActivatedRoute,
    private loaderservice: LoaderServiceService,
  ) {
    this._navService.hideSidebarAndNav = false;
  }
  public totalData: number = 0;
  accountHash: any;
  entHash: any;
  entityHash: any;
  businessPostData: any = [];
  ngOnInit(): void {
    this.isLoading = true;
    this.loaderservice.showLoader = true;
    this.route.queryParams.subscribe((data) => {
      console.log(data.entityHash);
      this.entHash = data.entPubHash;
      this.entityHash = data.entityHash;
      this.accountHash = localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID);
      this._apiService.getFeedAsPerBusinessID(
        this.accountHash,
        this.entHash,
        this.page.toString(),
      );
    });
    // this.modelSubscription = this._modelRef.afterAllClosed.subscribe((data) => {
    //   this.isLoading = true;
    //   this._apiService.getAdminPostInfoList(this.page.toString());
    // });
    this._apiSubscription = this._apiService.apiResult.subscribe((response) => {
      console.log(response);
      if (
        response.responseType ===
        SM_CONSTANTS.RESULT_API_GET_FEED_AS_PER_BUSINESS_ID
      ) {
        this.businessPostData = [];
        if (response.result) {
          this.businessPostData = response.result;
          this.businessPostData.forEach((element: any) => {
            element.assetInfo =
              typeof element.assetInfo == "string"
                ? JSON.parse(element.assetInfo)
                : element.assetInfo;
          });
          this.totalData = this.businessPostData[0].total_count;
        }
        this.isLoading = false;
        this.loaderservice.showLoader = false;
      }
      if (response.responseType === SM_CONSTANTS.RESULT_API_UPDATE_POST_INFO) {
        if (response.result) {
          this._apiService.getFeedAsPerBusinessID(
            this.accountHash,
            this.entHash,
            this.page.toString(),
          );
        }
      }

      if (
        response.responseType ===
        SM_CONSTANTS.RESULT_API_GET_POST_CREATE_ELIGIBILITY
      ) {
        if (response.result) {
          this.loaderservice.showLoader = false;
          if (response.result.eligibility_status == 0) {
            const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
              data: {
                title: "Alert",
                message:
                  "You reached the maximum limit of post creation for this month. Contact support if you need more.",
                okbtn: "Ok",
                cancelbtn: "Cancel",
                type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
              },
              disableClose: true,
            });
          } else {
            let dialogref = this.dialog.open(AddBusinessPostComponent, {
              width: "600px",
              data: {},
            });
            dialogref.afterClosed().subscribe((res) => {
              if (res) {
                // this._apiService.getFeedAsPerBusinessID(this.accountHash,this.entHash,this.page.toString())
              }
            });
          }
        }
      }
    });
  }

  openModel(event: any) {
    this._modelRef.open(AddAdminPostComponent, {
      minWidth: "400px",
      data: {
        title: "Edit business post",
        type: SM_CONSTANTS.BUISNESS_PROMOTION,
        ref: this._modelRef,
        data: event,
      },
    });
  }

  ngOnDestroy() {
    this._apiSubscription.unsubscribe();
    this.modelSubscription.unsubscribe();
  }

  onPageChange(ev: any) {
    this.loaderservice.showLoader = true;
    this.page = ev?.pageIndex + 1;
    this._apiService.getFeedAsPerBusinessID(
      this.accountHash,
      this.entHash,
      this.page.toString(),
    );
  }

  onCreateNewPost() {
    this._modelRef.open(AddAdminPostComponent, {
      minWidth: "400px",
      data: {
        title: "Add admin post",
        type: SM_CONSTANTS.ADMIN_POST,
        ref: this._modelRef,
      },
    });
  }

  openvideo() {
    this.dialog.open(YoutubeEmbedVideoComponent, {
      width: "1000px",
      disableClose: true,
      data: {
        link: "",
        title: "Business profile",
      },
    });
  }

  opencontact() {
    this.router.navigate(["/contact-us"]);
  }

  openLink(url: string): void {
    window.open(url, "_blank");
  }

  openAddPost() {
    this.loaderservice.showLoader = true;
    this._apiService.getPostCreateEligibility(this.entityHash);
  }

  openpostsetting() {
    this.loaderservice.showLoader = true;
    this.dialog.open(PublicPostSettingsComponent, {
      width: "400px",
      data: {
        entityHash: this.entityHash,
      },
    });
  }
}
